import React, { use } from 'react';
import "../../styles/home/view_top_votes.css";
import { useEffect, useState } from "react";
import { useSearchContext } from '../chats/searchContext';
import { Link, useNavigate } from 'react-router-dom';
import searchIcon from "../../images/chats/search_icon.png";

const ViewTopVotes = () => {
    const {getVotedList} = useSearchContext();
    const navigate = useNavigate();
    const [getSearch, setSearch] = useState("");
    const [getIsTopListLoading, setIsTopListLoading] = useState(true);
    const [getOriginalTopList, setOriginalTopList] = useState({});
    const [getTopList, setTopList] = useState({});

    const onChangeSearch = (search) => {
        setSearch(search.target.value);
    };

    const goBack = () => {
        navigate(-1);
    };

    const sortTopVotes = () => {
        const originalList = {};
        getVotedList.map((card) => {
            const genre = card.section.split("_")[0].toLowerCase();
            const type = card.section.split("_")[1].toLowerCase();

            if (!originalList[genre]) {
                originalList[genre] = {};
            }
    
            if (!originalList[genre][type]) {
                originalList[genre][type] = {};
            }

            originalList[genre][type].name = card.name;
            originalList[genre][type].overview = card.overview;
            originalList[genre][type].image = card.image;
            originalList[genre][type].type = type;
            originalList[genre][type].id = card.id;
        });

        setTopList(originalList);
        setOriginalTopList(originalList);
        setIsTopListLoading(false);
    };

    useEffect(() => {
        const filtered = Object.keys(getOriginalTopList).reduce((acc, key) => {
            if (key.toLowerCase().includes(getSearch.toLowerCase())) {
                acc[key] = getOriginalTopList[key];
            }
            return acc;
        }, {});
    
        setTopList(filtered);
    }, [getSearch, getOriginalTopList]);

    useEffect(() => {
        sortTopVotes();
    }, [getVotedList]);

    return (
        <div className='view_top_votes_screen'>
            <div className="home_view_discussions_header">
                <p className="vote_section_screen_header">⭐ Top Votes</p>
                <p onClick={goBack} className="home_view_discussions_back">back</p>
            </div>
            <div className="vote_screen_divider"></div>

            <div className="vote_screen_search_input_container_i">
                <div className="vote_screen_search_input_container">
                    <img src={searchIcon} className="vote_screen_search_input_icon"/>
                    <input className="vote_screen_search_input_field" id="item_section_search" placeholder={`Search for any category`} type="text" value={getSearch} onChange={onChangeSearch} />
                </div>
            </div>

            <div className="top_votes_content">
                {
                    Object.keys(getTopList).length > 0
                    ? Object.entries(getTopList).map(([key, value, index]) => {    
                        const name = key;

                        return(
                            <div key={index} className='top_votes_sect'>
                                <p style={{width: "max-content"}} className='top_votes_sect_header'>{name.charAt(0).toUpperCase()}{name.slice(1)}</p>
                                <div className='top_votes_sect_row'>
                                    {
                                        value["movie"]
                                        ? <Link className='top_votes_link' to={`/main_back/home/${name.toLowerCase()}/movie/${value["movie"].id}`}><div className='top_votes_sect_column'>
                                            <div className='top_votes_sect_image' style={{backgroundImage: `url("https://image.tmdb.org/t/p/w500${value["movie"].image}")`}}>
                                                <p className='top_votes_sect_sub'>Movie</p>
                                            </div>
                                            <p className='top_votes_sect_name'>{value["movie"].name}</p>
                                        </div></Link>
                                        : null
                                    }

                                    {   
                                        value["series"]
                                        ? <Link className='top_votes_link' to={`/main_back/home/${name.toLowerCase()}/series/${value["series"].id}`}><div className='top_votes_sect_column'>
                                            <div className='top_votes_sect_image' style={{backgroundImage: `url("https://image.tmdb.org/t/p/w500${value["series"].image}")`}}>
                                                <p className='top_votes_sect_sub'>Series</p>
                                            </div>
                                            <p className='top_votes_sect_name'>{value["series"].name}</p>
                                        </div></Link>
                                        : null
                                    }
                                </div>
                            </div>
                        )
                    })
                    : getIsTopListLoading
                        ? <p style={{alignSelf: 'center', color: 'aliceblue', fontSize: '18px', textAlign: "center"}}>Loading...</p>
                        : getVotedList.length > 0
                            ? <p style={{alignSelf: 'center', color: 'aliceblue', fontSize: '18px', textAlign: "center"}}>There are no categories based on your search "{getSearch}"</p>
                            : <div className="vote_section_screen_no_votes_con">
                                <p className="vote_section_screen_no_votes_text">No votes have been cast for any category 🥲...</p>
                                <Link to={`/main_back/home`} className="vote_section_screen_link"><p className="vote_section_screen_no_votes_link">Nominate a movie or TV series.</p></Link>
                            </div>
                    }
            </div>
        </div>
    );
};

export default ViewTopVotes;